module.exports = __webpack_public_path__ + "static/Crowns 1 smile after-876aa151bc0aca9eea56b370cf7223a9.jpg";